import { render } from "./EmptyProfileItemMessage.vue?vue&type=template&id=261fdf68"
import script from "./EmptyProfileItemMessage.vue?vue&type=script&lang=js"
export * from "./EmptyProfileItemMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__